import React, { useEffect } from 'react';
import useTrack from '../../../hooks/useTrack/useTrack';
import AudioTrack from '../AudioTrack/AudioTrack';
import VideoTrack from '../VideoTrack/VideoTrack';
import DataTrack from '../DataTrack/DataTrack';

import { IVideoTrack } from '../../../types';
import {
  AudioTrack as IAudioTrack,
  DataTrack as IDataTrack,
  LocalTrackPublication,
  Participant,
  RemoteTrackPublication,
  Track,
} from 'twilio-video';
import { _extLog } from '../../../tools/ExternalLogs';

interface PublicationProps {
  publication: LocalTrackPublication | RemoteTrackPublication;
  participant: Participant;
  isLocalParticipant?: boolean;
  videoOnly?: boolean;
  videoPriority?: Track.Priority | null;
}

export default function Publication({ publication, isLocalParticipant, videoOnly, videoPriority }: PublicationProps) {
  const track = useTrack(publication);

  useEffect(() => {
    if (track) {
      _extLog(`Initialize track: ${track?.kind} id: ${track?.name}`);
    }
  }, [track]);

  if (!track) return null;

  switch (track.kind) {
    case 'video':
      return (
        <VideoTrack
          track={track as IVideoTrack}
          priority={videoPriority}
          isLocal={!track.name.includes('screen') && isLocalParticipant}
        />
      );
    case 'audio':
      return videoOnly ? null : <AudioTrack track={track as IAudioTrack} />;
    case 'data':
      return <DataTrack track={track as IDataTrack} />;
    default:
      return null;
  }
}
